// extracted by mini-css-extract-plugin
export default {"topbar-button":"Notification_topbar-button__Fmu3w","badge":"Notification_badge__bPppG"};